import ENV from "../env";

const DELETE_TIMEOUT_MS = 30000;

async function parseResponse(response) {
  const responseText = await response.text();
  if (!responseText) return {};

  try {
    return JSON.parse(responseText);
  } catch {
    return { error: responseText };
  }
}

const deleteParticipant = async (participant, fallbackEventId) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), DELETE_TIMEOUT_MS);
  const body = JSON.stringify({
    participant: {
      id: participant?.id,
      eventId: participant?.eventId || fallbackEventId,
    },
  });

  try {
    let response = await fetch(`${ENV.firebaseApiUrl}/participant/cancel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      signal: controller.signal,
      body,
    });

    if (response.status === 404) {
      response = await fetch(`${ENV.firebaseApiUrl}/participant/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        signal: controller.signal,
        body,
      });
    }

    const resData = await parseResponse(response);

    if (!response.ok) {
      throw new Error(
        resData.error || resData.message || `Delete participant failed (${response.status})`,
      );
    }

    return resData;
  } catch (error) {
    if (error?.name === "AbortError") {
      throw new Error("Delete participant request timed out");
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

export default deleteParticipant;
